<template>
  <b-card class="mb-3">  
    <b-form inline @submit.prevent @click="onFormClick">
      <label class="sr-only" for="inline-form-input-name">{{ placeholder }}</label>
      <b-row align-v="end">
        <b-col>
          <b-input
            :placeholder="placeholder"
            type="search"
            autocomplete="off"
          />
        </b-col>
        <b-col>
          <b-button variant="branded" class="ml-3">
            {{ buttonText }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
      }
    },
    computed: {
      placeholder() {
        return !!this.block && !!this.block.meta ?
          (this.block.meta.placeholder || trans('keywords')) :
          trans('keywords')
      },
      buttonText() {
        return !!this.block ?
          (this.block.button_text || trans('search')) :
          trans('search')
      },
      rowClass() {
        return 'row'
      },
      colClass() {
        return 'col-12'
      },
      isInIframe() {
        return window !== window.parent
      },
    },
    methods: {
      onFormClick() {
        this.$bvModal.show('algolia-search-modal')
      }
    },
    mounted() {
      window.pageSearchBlock = this
    },
  }
</script>